import {ListView} from '@github-ui/list-view'
import {ListViewMetadata} from '@github-ui/list-view/ListViewMetadata'
import type {Deployment} from '../types'
import {DeploymentRecordListItem} from './DeploymentRecordListItem'
import styles from './DeploymentRecordList.module.css'
import {Blankslate} from '@primer/react/experimental'
import {Heading, Link} from '@primer/react'

interface DeploymentRecordListProps {
  deployments: Deployment[]
}

export function DeploymentRecordList({deployments}: DeploymentRecordListProps) {
  const formatNumber = (num: number): string => {
    return num.toLocaleString()
  }
  const listTitle = `${formatNumber(deployments.length)} ${deployments.length === 1 ? 'record' : 'records'}`

  const emptyList = (
    <Blankslate border>
      <Blankslate.Heading className="f4">None detected</Blankslate.Heading>
      <Blankslate.Description>
        Link this artifact with your deployments using the{' '}
        <Link inline href="https://docs.github.com/en/rest/orgs/artifact-metadata?apiVersion=2022-11-28">
          artifact metadata API
        </Link>
      </Blankslate.Description>
    </Blankslate>
  )

  return (
    <div>
      <Heading as="h3" className={styles.Header}>
        Deployments
      </Heading>

      {deployments.length === 0 ? (
        emptyList
      ) : (
        <ListView
          variant="default"
          title=""
          className="border rounded"
          metadata={<ListViewMetadata title={listTitle} />}
        >
          {deployments.map(deployment => (
            <DeploymentRecordListItem key={deployment.deployment_name} deployment={deployment} />
          ))}
        </ListView>
      )}
    </div>
  )
}
